import { Icon } from '@iconify/react'
import React, { FunctionComponent, memo } from 'react'

import { AUCTION_STATES } from '../../../common/auctionScrapeTypes'
import { AuctionDetailDrawerQuery } from '../../../graphql/generated'
import { DRAWER_VIEW } from '../../../redux/drawerSlice'
import { useAppSelector } from '../../../redux/hooks'
import { Min } from '../DateFormat/DateFormat'
import { Fade } from '../Fade/Fade'
import { Money } from '../Money/Money'
import { PriceEstimateLayoutLvDataRow as Item } from '../PriceEstimateLayoutLvDataRow/PriceEstimateLayoutLvDataRow'

export interface AuctionDetailDrawerInfoProps {
  auction: AuctionDetailDrawerQuery['auctionListingById']
}

export const AuctionDetailDrawerInfo: FunctionComponent<AuctionDetailDrawerInfoProps> =
  memo(({ auction }) => {
    const isAssigmentMode =
      useAppSelector(state => state.drawer?.viewType) ===
      DRAWER_VIEW.ASSIGNMENT_MODE

    return (
      <div className="flex flex-col space-y-2 animate-fadeIn">
        <Fade show={!isAssigmentMode} className="flex flex-col space-y-2">
          <Item title="Stav">
            {auction?.state === AUCTION_STATES.UPCOMING
              ? 'Připravovaná'
              : 'Ukončená'}
          </Item>

          <Item title="Místo konání">
            <a
              className="flex items-center space-x-1"
              href={auction?.detailUrl}
              target="_blank"
              rel="noreferrer"
              title="Zobrazit detail dražby v novém okně"
            >
              <Icon
                icon="quill:link-out"
                className="-mb-0.5"
                width="12"
                height="12"
              />
              <span>{auction?.auctionedOn}</span>
            </a>
          </Item>

          <Item title="Datum zahájení">
            {auction?.startDate ? (
              <Min>{auction.startDate}</Min>
            ) : (
              <span className="text-gray-400">Neuvedeno</span>
            )}
          </Item>

          <Item title="Datum ukončení">
            {auction?.endDate ? (
              <Min>{auction.endDate}</Min>
            ) : (
              <span className="text-gray-400">Neuvedeno</span>
            )}
          </Item>

          <Item title="Cena">
            {(auction?.price || 0) > 0 ? (
              <Money
                amount={auction?.price}
                decimalNumbers={0}
                grayscale
                symbol="Kč"
              />
            ) : (
              <span className="text-gray-400">Neuvedeno</span>
            )}
          </Item>

          <Item title="Dražební vyhláška">
            {auction?.auctionDecreeUrl ? (
              <a
                href={auction.auctionDecreeUrl}
                target="_blank"
                rel="noreferrer"
                title="Zobrazit dražební vyhlášku v novém okně"
              >
                Stáhnout
              </a>
            ) : (
              <span className="text-gray-400">Neuvedeno</span>
            )}
          </Item>
        </Fade>

        {!auction?.description?.length || auction.description.length < 300 ? (
          <Item title="Popis dražby">
            {auction?.description || (
              <span className="text-gray-400">Neuvedeno</span>
            )}
          </Item>
        ) : (
          <div className="font-semibold text-justify">
            {!isAssigmentMode && (
              <div className="inline-block h-8 w-1/3 float-left font-normal">
                Popis dražby:
              </div>
            )}
            <div>{auction.description}</div>
          </div>
        )}
      </div>
    )
  })
